import { MapActionsSnackbarModule } from '@/store/snackbar/map-actions.snackbar';
import { ProdutoInterface } from '@/shared/models/produto/produto.interface';
import { ProdutoFilter } from '@/shared/models/produto/produto.filter';
import store from '@/store';
import queryUtil from '@/shared/utils/query.util';
import { instanciaAxios } from './base.service';

const produtos = 'produtos';

export default class ProdutoService {
  async buscarTodos(): Promise<any> {
    return await instanciaAxios.get(produtos)
      .then((response: any) => {
        const lista: Array<ProdutoInterface> = response.data;
        return lista;
      })
      .catch((error: any) => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error);
        console.error(error);
      });
  }

  // async buscarPorEAN(ean: number): Promise<any> {
  //   return await instanciaAxios.get(`${produtos}/${ean}`)
  //     .then((response: any) => {
  //       const cupom: ProdutoInterface = response.data;
  //       return cupom;
  //     })
  //     .catch((error: any) => {
  //       store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error);
  //       console.error(error);
  //     });
  // }

  async buscarPorEAN(ean: number): Promise<any> {
    return await instanciaAxios.get(`${produtos}/pesquisa?ean=${ean}`)
      .then((response: any) => {
        const lista: Array<ProdutoInterface> = response.data;
        return lista[0];
      })
      .catch((error: any) => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error);
        console.error(error);
      });
  }

  async buscarPorFiltro(filtro: ProdutoFilter): Promise<any> {
    const query = queryUtil.getQuery(filtro);
    return await instanciaAxios.get(`${produtos}/pesquisa${query}`)
      .then((response: any) => {
        const lista: Array<ProdutoInterface> = response.data;
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Pesquisa concluída!');
        return lista;
      })
      .catch((error: any) => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error);
        console.error(error);
      });
  }

  async salvar(body: ProdutoInterface): Promise<any> {
    await instanciaAxios.post(produtos, body)
      .then(() => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Produto cadastrado com sucesso!');
      })
      .catch((error: any) => {
        console.error(error.response);
        if (error.response.status === 500 && error.response.data.indexOf('Código EAN inválido!') !== -1) {
          store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, 'Código EAN inválido!');
        }
        return Promise.reject();
      });
  }

  async atualizar(body: ProdutoInterface): Promise<any> {
    await instanciaAxios.put(`${produtos}/${body.ean}`, body)
      .then(() => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Produto editado com sucesso!');
      })
      .catch((error: any) => {
        console.error(error.response);
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
        return Promise.reject();
      });
  }

  async excluir(produto: ProdutoInterface): Promise<any> {
    await instanciaAxios.delete(`${produtos}/${produto.ean}`)
      .then(() => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Produto excluído com sucesso!');
      })
      .catch((error) => {
        console.error(error.response);
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
        return Promise.reject();
      });
  }
}
